import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useReportContext } from '../../../../context/DetailContext';
import { useUser } from '../../../../context/UserContext';
import QuotaService from '../../../../service/quota/Quota';

const SERVICE_LABEL_MAP: Record<string, string> = {
  G: '등기부등본',
  H: '전입세대열람원',
};

interface Props {
  type: string;
  link: string;
  onClose: () => void;
}
function RegistryViewModal({ type, link, onClose }: Props) {
  const navigate = useNavigate();
  const { iidx } = useReportContext();
  const { user } = useUser();
  const [collapsed, setCollapsed] = useState(false);

  const typeLabel = SERVICE_LABEL_MAP[type];

  const [quotaAccess, setQuotaAccess] = useState(false);
  const [count, setCount] = useState(0);
  const [userLimit, setUserLimit] = useState(0);

  const getValue = (list: any[]) => {
    const f = list.find((x) => x.type === type);
    return { count: f?.count ?? 0, limit: f?.limit ?? 0 };
  };
  // 서비스 이용권 확인
  const checkQuota = async () => {
    try {
      const res = await QuotaService.count();
      const value = getValue(res.data);

      setCount(value.count);
      setUserLimit(value.limit);
      setQuotaAccess(value.limit > value.count);
    } catch (error) {
      console.log(error);
    }
  };

  // 서비스 이용권 사용
  const serviceQuota = async (type: string, iidx: number) => {
    try {
      const data = {
        type,
        iidx,
      };
      await QuotaService.use(data);
    } catch (err) {
      console.log(err, '발생');
    }
  };

  const handleClickButton = () => {
    serviceQuota(type, Number(iidx));
    window.open(link, '_blank');
    checkQuota();
  };

  useEffect(() => {
    checkQuota();
  }, [user]);

  return (
    <Container>
      <Header>
        <HeaderIconButton onClick={onClose}>
          <img src="/assets/images/close/close-black-24.svg" alt="" />
        </HeaderIconButton>
        <HeaderTitle />
        <HeaderIconButton onClick={() => navigate('/')}>
          <img src="/assets/images/icon/home-black.svg" alt="" />
        </HeaderIconButton>
      </Header>
      <Content>
        <Section $gap={16}>
          <TitleSection>
            <Title>{typeLabel} 열람</Title>
            <RowContent $gap={2}>
              <TicketNumberBox>
                보유 이용권
                <TicketNumber>{userLimit - count}개</TicketNumber>
              </TicketNumberBox>
              {/* <Dot>・</Dot>
              <TicketNumberBox>
                사용 후 이용권{' '}
                <TicketNumber $left>{remainingTickets - 1}개</TicketNumber>
              </TicketNumberBox> */}
            </RowContent>
          </TitleSection>
          <ViewSection>
            <RowContent $gap={8}>
              <UseTicketLabel>
                <img src="/assets/images/icon/membership.svg" alt="" />
                {typeLabel} 열람 이용권
              </UseTicketLabel>
              <UseTicketNumber>1개 사용</UseTicketNumber>
            </RowContent>
            <ViewButton onClick={handleClickButton}>
              {typeLabel} 열람하기
            </ViewButton>
            {/* <RecentView>
              <RecentViewLabelBox>
                최근 열람
                <RecentViewDate>25.05.30 12:36</RecentViewDate>
              </RecentViewLabelBox>
              <ViewHistoryButton>열람 내역 {'>'}</ViewHistoryButton>
            </RecentView> */}
          </ViewSection>
        </Section>
        <Divider />
        <Section $gap={12}>
          <InfoTitleContainer onClick={() => setCollapsed((v) => !v)}>
            <InfoTitle>이용권 안내</InfoTitle>
            <ArrowButton
              aria-expanded={!collapsed}
              aria-controls="registry-view-table"
              $collapsed={collapsed}
              title={collapsed ? '펼치기' : '접기'}
            >
              <img
                src="/assets/images/arrow/arrow-up-gray.svg"
                alt={collapsed ? '펼치기' : '접기'}
              />
            </ArrowButton>
          </InfoTitleContainer>
          {!collapsed && (
            <>
              <Table id="registry-view-table">
                <colgroup>
                  <col width={92} />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <Th>구분</Th>
                    <Th>등기부등본 / 전입세대열람원</Th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <Td>스탠다드</Td>
                    <Td>월 1,000개 제공</Td>
                  </tr>
                  <tr>
                    <Td>프리미엄</Td>
                    <Td>무제한</Td>
                  </tr>
                </tbody>
              </Table>
              {/* <DescSection>
                <Desc>・일반 열람 : 물건 등록 시점의 등기 조회</Desc>
                <Desc>・실시간 열람 : 실시간으로 발급하여 등기 조회</Desc>
              </DescSection> */}
            </>
          )}
        </Section>
      </Content>
    </Container>
  );
}

export default RegistryViewModal;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  padding: 6px;
  align-items: center;
  gap: 2px;
`;

const HeaderIconButton = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
`;

const HeaderTitle = styled.div`
  display: flex;
  height: 44px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
`;

const Content = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`;

const Section = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ $gap }) => `${$gap ?? 0}px`};
  align-self: stretch;
`;

const TitleSection = styled(Section)`
  gap: 12px;
`;

const Title = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const RowContent = styled.div<{ $gap?: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ $gap }) => `${$gap ?? 0}px`};
  align-self: stretch;
`;

const TicketNumberBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const TicketNumber = styled.div<{ $left?: boolean }>`
  color: ${({ $left }) => ($left ? '#008AFF' : 'rgba(0, 12, 30, 0.80)')};
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const Dot = styled.div`
  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const ViewSection = styled.div`
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #008aff;
  background: #fff;
`;

const UseTicketLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 0 0;

  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const UseTicketNumber = styled.div`
  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ViewButton = styled.div`
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: 100%;
  border-radius: 8px;
  background: #008aff;

  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const RecentView = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  background: rgba(2, 32, 71, 0.05);
`;

const RecentViewLabelBox = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  color: #008aff;
  font-size: 12px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

const RecentViewDate = styled.div`
  color: #222;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.3px;
`;

const ViewHistoryButton = styled.div`
  display: flex;
  padding: 4px 12px;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  background: #fff;

  color: rgba(0, 12, 30, 0.8);
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
`;

const Divider = styled.div`
  height: 1px;
  flex-shrink: 0;
  align-self: stretch;
  background: #e1e2e4;
`;

const InfoTitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

const InfoTitle = styled.div`
  flex: 1 0 0;
  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const ArrowButton = styled.button<{ $collapsed: boolean }>`
  border: none;
  outline: none;
  background: none;
  padding: 4px;
  cursor: pointer;
  transform: rotate(${({ $collapsed }) => ($collapsed ? '180deg' : '0deg')});
  transition: transform 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

const Th = styled.th`
  width: 100%;
  padding: 10px 24px;
  background: #f7f8fc;
  border-bottom: 1px solid #e1e2e4;
  border-top: 1px solid #e1e2e4;

  color: #616161;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.3px;
  &:not(:first-child) {
    border-left: 1px solid #e1e2e4;
  }
`;

const Td = styled.td`
  padding: 8px 12px;
  border-bottom: 1px solid #e1e2e4;

  color: #222;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.3px;

  &:not(:first-child) {
    border-left: 1px solid #e1e2e4;
  }
`;

const DescSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  align-self: stretch;
`;

const Desc = styled.div`
  align-self: stretch;
  color: #6b7684;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;
